/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'phone': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M15.4 20C6.908 20 0 13.092 0 4.6A4.605 4.605 0 016.09.248a1 1 0 01.648.722l1.37 5.964c.075.328-.02.672-.253.916-.137.142-.14.145-1.38.794a9.947 9.947 0 004.88 4.883c.649-1.241.653-1.245.795-1.381.245-.234.59-.325.917-.253l5.964 1.369a1 1 0 01.72.646c.083.236.144.48.185.731A4.605 4.605 0 0115.4 20z" _fill="#fff"/>'
  }
})
